import axios from 'axios'

const BASE_URL = '/api/driver-invoices'

export default {
  // List invoices with optional filters
  list(params = {}) {
    return axios.get(`${BASE_URL}/`, { params })
  },

  // Get invoice detail
  get(id) {
    return axios.get(`${BASE_URL}/${id}/`)
  },

  // Generate a single invoice (date range)
  generate(data) {
    return axios.post(`${BASE_URL}/`, data)
  },

  // Generate monthly invoice
  generateMonthly(data) {
    return axios.post(`${BASE_URL}/generate-monthly/`, data)
  },

  // Bulk generate invoices for multiple drivers
  generateBulk(data) {
    return axios.post(`${BASE_URL}/generate-bulk/`, data)
  },

  // Update invoice status (draft -> confirmed -> paid)
  updateStatus(id, status) {
    return axios.patch(`${BASE_URL}/${id}/status/`, { status })
  },

  // Cancel an invoice
  cancel(id) {
    return axios.post(`${BASE_URL}/${id}/cancel/`)
  },

  // Delete a draft invoice
  delete(id) {
    return axios.delete(`${BASE_URL}/${id}/`)
  },

  // Preview eligible orders
  previewEligible(params) {
    return axios.get(`${BASE_URL}/eligible-orders/`, { params })
  },

  // Get list of drivers (delivery_man + pickupeur)
  getDrivers() {
    return axios.get('/api/auth/users/', {
      params: { role: 'delivery_man', can_receive_commission: true },
    })
  },

  // Get all commission-eligible users (delivery_man + pickupeur)
  getAllDrivers() {
    return Promise.all([
      axios.get('/api/auth/users/', { params: { role: 'delivery_man' } }),
      axios.get('/api/auth/users/', { params: { role: 'pickupeur' } }),
    ]).then(([deliveryRes, pickupRes]) => {
      const d = deliveryRes.data.results || deliveryRes.data
      const p = pickupRes.data.results || pickupRes.data
      return [...d, ...p]
    })
  },
}
